import { MdDelete } from "react-icons/md";
import { formatDistanceToNow } from "date-fns";

const Replies = ({ el, user, deleteComment, i, parent }) => {
  return (
    <>
      {el.parentId === parent._id && (
        <div
          key={i}
          className="relative mt-4 border border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] bg-white dark:bg-black dark:border-white/30 dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)]"
        >
          <div className="bg-white dark:bg-black p-4">
            <div className="flex justify-between items-start mb-4 border-b-2 border-dashed border-gray-300 dark:border-gray-700 pb-3">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 border border-black bg-gray-100 flex-shrink-0">
                  {el.user_id?.avatar ? (
                    <img
                      alt={el.user_id?.name || "avatar"}
                      src={el.user_id.avatar}
                      className="w-full h-full object-cover grayscale"
                    />
                  ) : (
                    <span className="flex items-center justify-center w-full h-full text-black dark:text-white font-black font-mono uppercase text-xs">
                      {el.user_id?.name?.charAt(0) || "U"}
                    </span>
                  )}
                </div>

                <div className="flex flex-col">
                  <span className="font-mono font-black text-black dark:text-white text-xs uppercase tracking-widest leading-none mb-1">
                    {el.user_id?.name}
                  </span>
                  <span className="text-[10px] font-mono tracking-widest text-gray-500 dark:text-gray-400 uppercase font-bold">
                    LOGGED:{" "}
                    {formatDistanceToNow(new Date(el.createdAt), {
                      addSuffix: true,
                    })}
                  </span>
                </div>
              </div>

              {el.user_id?.email === user?.email && (
                <button
                  onClick={() => deleteComment(el._id, parent._id)}
                  className="p-1 px-2 border border-black dark:border-white/30 hover:bg-black dark:hover:bg-white hover:text-white dark:hover:text-black transition-colors"
                  title="Purge Record"
                >
                  <MdDelete className="text-sm" />
                </button>
              )}
            </div>

            <p className="text-black dark:text-white font-mono text-xs leading-relaxed whitespace-pre-wrap uppercase font-bold pl-3 border-l-4 border-gray-200 dark:border-gray-700">
              {el.message}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default Replies;
